// Offer reducer

import AuthClient from '../../../api/auth/AuthClient';

import {
  OFFERS_ACTIONS,
  offerEventBuilder
} from '../../../infrastructure/middleware/analytics/analyticsObjectBuilders';
import { pushEvent } from '../../../utilities/dataLayerUtils';
import { initializeState } from '../../../utilities/storageUtils';
import offerActionTypes from './offer.types';

const authClient = new AuthClient();

export const getDefaultOfferCode = (fallbackValue = '') => {
  const isUserLoggedIn = authClient.isLoggedIn();
  const promoCodeList = window.promoCodeList ? JSON.parse(window.promoCodeList) : [];
  const relatedOfferCode = promoCodeList.find(item => item.promoCode === window.dealPromoCode);
  const isGatedOffer = relatedOfferCode && JSON.parse(relatedOfferCode.isExclusive);

  if (isGatedOffer && !isUserLoggedIn) {
    return fallbackValue;
  }

  return window.dealPromoCode || fallbackValue;
};

const INITIAL_STATE = {
  code: getDefaultOfferCode(),
  description: '',
  errorMessage: '',
  activeOffers: [],
  emailOffers: [],
  appliedViaPromoBanner: false,
  promoBannerPersonalization: null
};

const offerReducer = (state, action) => {
  state = initializeState(state, INITIAL_STATE);

  switch (action.type) {
    case offerActionTypes.ADD_OFFER_CODE:
      return { ...state, code: action.code };
    case offerActionTypes.SET_OFFER_CODE_DESCRIPTION:
      return {
        ...state,
        description: action.description,
        errorMessage: ''
      };
    case offerActionTypes.REMOVE_OFFER_CODE:
      return {
        ...state,
        code: '',
        appliedViaPromoBanner: false,
        promoBannerPersonalization: null
      };
    case offerActionTypes.SET_OFFER_APPLIED_VIA_PROMO_BANNER:
      return {
        ...state,
        appliedViaPromoBanner: action.isApplied,
        promoBannerPersonalization: action.isApplied ? action.promoPersonalization ?? null : null
      };
    case offerActionTypes.ON_OFFER_CODE_ERROR:
      return {
        ...state,
        errorMessage: action.errorMessage,
        description: ''
      };
    case offerActionTypes.ADD_ACTIVE_OFFER: {
      const eventObject = offerEventBuilder(OFFERS_ACTIONS.ADD, {
        resortLocation: action.offerData.resortLocation,
        name: action.offerData.title,
        value: -action.offerData.dollarValue
      });
      pushEvent(eventObject);
      const activeOffers = [...state.activeOffers];
      if (!activeOffers.includes(action.offerData.id)) {
        activeOffers.push(action.offerData.id);
        return { ...state, activeOffers: activeOffers };
      }
      return state;
    }
    case offerActionTypes.ADD_ACTIVE_EMAIL_OFFER: {
      const emailOffers = [...state.emailOffers];
      if (!emailOffers.includes(action.offerData.id)) {
        emailOffers.push(action.offerData.id);
        return { ...state, emailOffers: emailOffers };
      }
      return state;
    }
    case offerActionTypes.REMOVE_ACTIVE_OFFER: {
      const eventObject = offerEventBuilder(OFFERS_ACTIONS.REMOVE, {
        resortLocation: action.offerData.resortLocation,
        name: action.offerData.title,
        value: -action.offerData.dollarValue
      });
      pushEvent(eventObject);
      const activeOffers = state.activeOffers.filter(offer => offer !== action.offerData.id);
      const activeEmailOffers = state.emailOffers.filter(offer => offer !== action.offerData.id);
      return { ...state, activeOffers: activeOffers, emailOffers: activeEmailOffers };
    }
    case offerActionTypes.REMOVE_ALL_ACTIVE_OFFERS: {
      return { ...state, activeOffers: [], emailOffers: [] };
    }
    case offerActionTypes.VERIFY_ACTIVE_OFFERS: {
      const activeOffers = [...state.activeOffers];
      const currentUserOffers = action.offerData;
      const verifiedActiveOffer = activeOffers.filter(offerId =>
        currentUserOffers.some(offerObj => offerObj.id === offerId)
      );

      return { ...state, activeOffers: verifiedActiveOffer };
    }
    default:
      return state;
  }
};

export default offerReducer;
